import { FormGroup } from '@angular/forms';
import { Agenda } from './agenda';
import { SelectItem } from 'primeng/api';

export class Dia {
  /**
   * Código
   */
  private _codigo: string;
  /**
   * Encabezado
   */
  private _encabezado: string;
  /**
   * Formulario
   */
  private _formulario: FormGroup;
  /**
   * Datos
   */
  private _datos: Agenda[];
  /**
   * Items
   */
  private _items: SelectItem[];
  /**
   * Indicador
   */
  private _indicador: string;
  /**
   * Cargando
   */
  private _cargando: boolean;
  /**
   * Submitted
   */
  private _submitted: boolean;
  /**
   * Para poligonos
   */
  private _forPoligonos: FormGroup;
  /**
   * Sub poligonos
   */
  private _subPoligonos: boolean;
  /**
   * Poligonos
   */
  private _poligonos: any[];
  /**
   * Código existe
   */
  private _codExiste: boolean;
  /**
   * Indicador poligonos
   */
  private _indPoligonos: boolean;
  /**
   * Agenda seleccionada
   */
  private _ageSeleccionada: Agenda;
  /**
   * Mapa
   */
  private _mapa: any;
  /**
   * Actualizar
   */
  private _actualizar: boolean;

  /**
   * Constructor de la clase
   * @param codigo
   * @param encabezado
   * @param formulario
   * @param datos
   * @param items
   * @param cargando
   * @param indicador
   */
  constructor( codigo?: string, encabezado?: string, formulario?: FormGroup, datos?: Agenda[], items?: SelectItem[], cargando?: boolean, indicador?: string ) {
    if ( codigo ) {
      this._codigo = codigo;
    }
    if ( encabezado ) {
      this._encabezado = encabezado;
    }
    if ( formulario ) {
      this._formulario = formulario;
    }
    if ( datos ) {
      this._datos = datos;
    } else {
      this._datos = [];
    }
    if ( items ) {
      this._items = items;
    } else {
      this._items = [];
    }

    if ( cargando ) {
      this._cargando = cargando
    } else {
      this._cargando = false;
    }

    if ( indicador ) {
      this._indicador = indicador;
    }

    this._poligonos = [];

  }
  /**
   * Get código
   */
  get codigo(): string {
    return this._codigo;
  }
  /**
   * Set código
   * @param value
   */
  set codigo( value: string ) {
    this._codigo = value;
  }
  /**
   * Get encabezado
   */
  get encabezado(): string {
    return this._encabezado;
  }
  /**
   * Set encabezado
   * @param value
   */
  set encabezado( value: string ) {
    this._encabezado = value;
  }
  /**
   * Get formulario
   */
  get formulario(): FormGroup {
    return this._formulario;
  }
  /**
   * Set formulario
   * @param value
   */
  set formulario( value: FormGroup ) {
    this._formulario = value;
  }
  /**
   * Get datos
   */
  get datos(): Agenda[] {
    return this._datos;
  }
  /**
   * Set datos
   * @param value
   */
  set datos( value: Agenda[] ) {
    this._datos = value;
  }
  /**
   * Get items
   */
  get items(): SelectItem[] {
    return this._items;
  }
  /**
   * Set items
   * @param value
   */
  set items( value: SelectItem[] ) {
    this._items = value;
  }
  /**
   * Get cargando
   */
  get cargando(): boolean {
    return this._cargando;
  }
  /**
   * Set cargando
   * @param value
   */
  set cargando( value: boolean ) {
    this._cargando = value;
  }
  /**
   * Get indicador
   */
  get indicador(): string {
    return this._indicador;
  }
  /**
   * Set indicador
   * @param value
   */
  set indicador( value: string ) {
    this._indicador = value;
  }
  /**
   * Get submitted
   */
  get submitted(): boolean {
    return this._submitted;
  }
  /**
   * Set submitted
   * @param value
   */
  set submitted( value: boolean ) {
    this._submitted = value;
  }
  /**
   * Get para poligonos
   */
  get forPoligonos(): FormGroup {
    return this._forPoligonos;
  }
  /**
   * Set para poligonos
   * @param value
   */
  set forPoligonos( value: FormGroup ) {
    this._forPoligonos = value;
  }
  /**
   * Get sub poligonos
   */
  get subPoligonos(): boolean {
    return this._subPoligonos;
  }
  /**
   * Set para poligonos
   * @param value
   */
  set subPoligonos( value: boolean ) {
    this._subPoligonos = value;
  }
  /**
   * Get poligonos
   */
  get poligonos(): any[] {
    return this._poligonos;
  }
  /**
   * Set poligonos
   * @param value
   */
  set poligonos( value: any[] ) {
    this._poligonos = value;
  }
  /**
   * Get existe código
   */
  get codExiste(): boolean {
    return this._codExiste;
  }
  /**
   * Set existe código
   * @param value
   */
  set codExiste( value: boolean ) {
    this._codExiste = value;
  }
  /**
   * Get ind poligonos
   */
  get indPoligonos(): boolean {
    return this._indPoligonos;
  }
  /**
   * Set ind poligonos
   * @param value
   */
  set indPoligonos( value: boolean ) {
    this._indPoligonos = value;
  }
  /**
   * Get agenda seleccionada
   */
  get ageSeleccionada(): Agenda {
    return this._ageSeleccionada;
  }
  /**
   * Set agenda seleccionada
   * @param value
   */
  set ageSeleccionada( value: Agenda ) {
    this._ageSeleccionada = value;
  }
  /**
   * Get mapa
   */
  get mapa(): any {
    return this._mapa;
  }
  /**
   * Set mapa
   * @param value
   */
  set mapa( value: any ) {
    this._mapa = value;
  }
  /**
   * Get actualizar
   */
  get actualizar(): boolean {
    return this._actualizar;
  }
  /**
   * Set actualizar
   * @param value
   */
  set actualizar( value: boolean ) {
    this._actualizar = value;
  }
}
